import React from "react";
import { GroupRoleItemView } from "./view";
import { styles } from "./styles";

export class GroupRoleItem extends React.Component {
  render() {
    return <GroupRoleItemView {...this.props} styles={styles} />;
  }
}
